import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration
import tableLoteryReportView from 'jet-views/reports/loteryReport/tableLoteryReport'; // Importing tableLoteryReportView

/**
 * Class representing the recordTableLoteryReportView.
 * @extends JetView
 */
export default class recordTableLoteryReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for detailed view of casino transactions
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'windowDetailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable for details
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: _('Detalles'), // Tooltip for details
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Icon template
                        },
                    },
                    { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                    { id: 'Code', header: _('Code'), width: 100, sort: 'int' }, // Code column
                    {
                        id: 'TransactionId',
                        header: _('Transacción ID'), // Transaction ID column
                        width: 300,
                        sort: 'int',
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                    {
                        id: 'Amount',
                        header: _('Valor'), // Amount column
                        width: 100,
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        sort: 'int',
                    },
                    {
                        id: 'CreateLocalDate',
                        header: _('Fecha Creación'), // Creation date column
                        width: 150,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get item on click
                        vthis.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
                        $$('detailsCasino').show(); // Show details window
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            id: 'tableDetail', // Main data table ID
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: false,
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Detalles'), // Tooltip for details
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon template
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                { id: 'Code', header: _('Code'), width: 100, sort: 'int' }, // Code column
                {
                    id: 'TransactionId',
                    header: _('Transacción ID'), // Transaction ID column
                    width: 300,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: _('Valor'), // Amount column
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    sort: 'int',
                },
                {
                    id: 'CreateLocalDate',
                    header: _('Fecha Creación'), // Creation date column
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get item on click
                    this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
                },
            },
            tooltip: true, // Enable tooltips
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerAA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetail'; // API URL for fetching report details
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails').clearAll(); // Clear details table
            $$('dtDetails').load(url + '?id=' + idUser); // Load details table data
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get item on grid click
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
